/**
 * ContentRulesModal — le regole sui contenuti, accettate prima di creare (#65).
 *
 * Lo apre il servizio `contentRules` la prima volta che un contenuto sta per
 * partire. «Accetto» lascia proseguire, «Non ora» ferma la pubblicazione.
 */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ContentRulesModal({ open, onAccept, onDecline }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return undefined;
    const esc = (e) => e.key === "Escape" && onDecline && onDecline();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [open, onDecline]);

  if (!open) return null;

  return (
    <div style={overlay}>
      <div role="dialog" aria-modal="true" aria-labelledby="content-rules-title" style={card}>
        <h2 id="content-rules-title" style={title}>{t("ui.moderation.rulesTitle")}</h2>
        <p style={body}>{t("ui.moderation.rulesLead")}</p>
        <ul style={lista}>
          {["rule1", "rule2", "rule3", "rule4"].map((k) => (
            <li key={k} style={{ marginBottom: 4 }}>{t(`ui.moderation.${k}`)}</li>
          ))}
        </ul>
        <p style={body}>{t("ui.moderation.rulesFooter")}</p>
        <p style={{ ...body, margin: "0 0 20px" }}>
          <a href="/terms#content-rules" target="_blank" rel="noopener noreferrer" style={link}>
            {t("ui.moderation.rulesLink")}
          </a>
        </p>
        <button type="button" onClick={onAccept} style={primario} data-testid="content-rules-accept">
          {t("ui.moderation.rulesAccept")}
        </button>
        <button type="button" onClick={onDecline} style={secondario} data-testid="content-rules-decline">
          {t("ui.moderation.rulesDecline")}
        </button>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
  zIndex: 1310, // sopra la testata col logo (1200)
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
};
const card = {
  background: "var(--color-surface, #fff)",
  borderRadius: "2rem",
  padding: 28,
  maxWidth: 420,
  width: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
};
const title = {
  fontFamily: "var(--font-display)",
  fontSize: 22,
  fontWeight: 800,
  color: "var(--color-text)",
  margin: "0 0 10px",
};
const body = {
  fontFamily: "var(--font-body)",
  fontSize: 14,
  lineHeight: 1.55,
  color: "var(--color-textMuted)",
  margin: "0 0 10px",
};
const lista = {
  fontFamily: "var(--font-body)",
  fontSize: 14,
  lineHeight: 1.5,
  color: "var(--color-text)",
  margin: "0 0 12px",
  paddingLeft: 20,
};
const link = { color: "var(--color-primary, #a8275a)", fontWeight: 700 };
const primario = {
  width: "100%",
  padding: "14px 20px",
  border: "none",
  borderRadius: 16,
  fontFamily: "var(--font-body)",
  fontSize: 16,
  fontWeight: 700,
  background: "linear-gradient(135deg, var(--color-primary, #a8275a), var(--color-primaryBright, #ff709f))",
  color: "#fff",
  cursor: "pointer",
  marginBottom: 8,
};
const secondario = {
  ...primario,
  background: "var(--color-bgAlt, #f5eef1)",
  color: "var(--color-text)",
  fontWeight: 600,
  marginBottom: 0,
};
